import { z } from 'zod';
import { NameSchema } from "../../../../common/validators/value-objects.js";
// Sign-up input
export const SignUpInputDTOSchema = z.object({
    email: z.email(),
    password: z.string().min(8),
    name: NameSchema,
});
// Sign-up request (HTTP structure)
export const SignUpRequestDTOSchema = z.object({
    body: SignUpInputDTOSchema,
});
//# sourceMappingURL=sign-up.dto.js.map